import { defineStore, storeToRefs } from "pinia";
import { computed } from "vue";
import { useSurveyProfilesStore } from "../surveyProfiles";

export const useProfileUrlParamsStore = defineStore("profileUrlParams", () => {
  // imported stores
  const surveyProfilesStore = useSurveyProfilesStore();
  const { selectedProfile } = storeToRefs(surveyProfilesStore);

  const currentUrlParams = computed(() => selectedProfile.value?.url_params || []);

  const addUrlParam = () => {
    selectedProfile.value.url_params.push({});
  };

  const removeUrlParam = (index) => {
    selectedProfile.value.url_params.splice(index, 1);
  };

  return {
    currentUrlParams,
    addUrlParam,
    removeUrlParam,
  };
});
